<template>
  <v-container fluid class="header-navigation">
    <v-row no-gutters>
      <v-col cols="4"> </v-col>
      <v-col
        cols="4"
        class="d-flex justify-center align-center align-self-center"
      >
        <div class="ak-user-ranks">
          <p class="mb-0 mr-5">
            <v-rating
              color="yellow"
              background-color="grey"
              empty-icon="mdi-star-outline"
              full-icon="mdi-star"
              half-icon="mdi-star-half-full"
              half-increments
              length="3"
              readonly
              size="30"
              v-model="averageStars"
            ></v-rating>
          </p>
          <p class="mb-0 mr-5">Rang {{ ranking }}</p>
          <p class="mb-0">{{ score }} Punkte</p>
        </div>
      </v-col>
      <v-col cols="4" class="d-flex justify-end align-center ak-user-info">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="100"
          offset-x
          z-index="10"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="ak-user-ranks align-center" v-bind="attrs" v-on="on">
              <span class="ak-user-name">{{ name }}</span>
              <AKAvatar
                :hasUserInfo="hasUserInfo"
                :avatar="avatar"
                :name="name"
              />
            </div>
          </template>

          <v-card>
            <v-list>
              <v-list-item class="py-2 justify-center">
                <AKAvatar
                  :hasUserInfo="hasUserInfo"
                  :avatar="avatar"
                  :name="name"
                />
              </v-list-item>
              <v-divider />
              <v-list-item>
                <router-link
                  :to="{ name: 'Einstellungen' }"
                  @click.native="menu = false"
                  class="ak-settings-link"
                >
                  Einstellungen
                </router-link>
              </v-list-item>
              <v-list-item>
                <a href="/oauth/logout">Logout</a>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AKAvatar from '@/components/common/core/AKAvatar';
export default {
  name: 'HeaderNavigation',
  components: { AKAvatar },
  data() {
    return {
      menu: false,
    };
  },
  props: {
    avatar: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    ranking: {
      type: Number,
      default: null,
    },
    score: {
      type: Number,
      default: null,
    },
    averageStars: {
      type: Number,
      default: 0.0,
    },
  },
};
</script>

<style lang="scss" scoped>
.header-navigation {
  background-color: var(--v-secondary-base);
  display: flex;
}

.ak-user {
  &-name {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    margin-right: 10px;
  }

  &-ranks {
    display: flex;
    flex-direction: row;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    align-items: center;
  }
}

.ak-settings-link {
  text-decoration: none;
}
</style>
